var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtnMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1153",
    "data-name": "Group 1153",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-arrow-small-left",
    d: "M25.514,13.506H10.5l4.939-4.938a1.5,1.5,0,1,0-2.117-2.132L6.886,12.89a2.954,2.954,0,0,0,0,4.218l6.44,6.455a1.5,1.5,0,0,0,2.117-2.132L10.5,16.508H25.514a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(-4.508 -2.999)",
    fill: "#15345a",
    stroke: "#f3f5f7",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnMobile);
export default __webpack_public_path__ + "static/media/backBtnMobile.6e4ad4061f21be575b7f9625e82d25db.svg";
export { ForwardRef as ReactComponent };